import React, { useState, useEffect,useCallback, useRef } from "react";
import {
  Center,
  Stack,
  HStack,
  AspectRatio,
  Heading,
  Text,
  Avatar,
  Box,
  Pressable,
  Modal,
  Button,
  View,
  Image,
  Spacer,
} from "native-base";
import {ScrollView, Dimensions,Platform } from 'react-native';
import { GlobalStyles } from "../constants/styles";
import { MaterialIcons } from "@expo/vector-icons";
import { Image as NativeImage } from "react-native";
import axios from "axios";
import CustomPopup from "./CustomPopup";
import ClipboardPopup from "./ClipboardPopup";
import { useSelector } from "react-redux";
import { GlobalConstants } from "../constants/constants";
import RenderHtml from 'react-native-render-html';  // Import RenderHtml

const AdCardForCitizen = ({ data, setSelectedPost }) => {
  let user = useSelector((state) => state.user.user);
  axios.defaults.headers.common = {
    Authorization: `bearer ${user ? user.token : null}`,
  };
  const [imageUrl, setImageUrl] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [detailPopUp, setDetailPopUp] = useState(false);
  const [saveButtonText, setSaveButtonText] = useState(
    data?.user_saved_ads?.length > 0 ? "UnSave" : "Save"
  );

  const [isClipboardPopupOpen, setIsClipboardPopupOpen] = useState(false);
  const screenWidth = window?.innerWidth > 600 ? 579 : 318 ;  
  const openClipboardPopup = () => {
    setIsClipboardPopupOpen(true);
  };

  const closeClipboardPopup = () => {
    setIsClipboardPopupOpen(false);
  };

  const shareClipboardPopup = async (selectedFriendIds) => {
    console.log(selectedFriendIds);
  };

  const openModal = (obj) => {
    setModalVisible(true);
    setImageUrl(data.ad_docs[0].url);
    // updateAdViews(obj);
  };

  const closeModal = () => {
    setImageUrl("");
    setModalVisible(false);
  };
  /// For Quil Editor

  const isHtmlContent = (content) => {
    const regex = /<[^>]*>/g;  // Check for HTML tags
    return regex.test(content);
  };

  const processTickText = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g; // Regex to extract URL
    const parts = text.split(urlRegex); // Split text into URL and non-URL parts
  
    return parts.map((part, index) =>
      urlRegex.test(part) ? (
        <Text
          key={index}
          style={{ color: "blue", textDecorationLine: "underline" }}
          onPress={() => Linking.openURL(part)}
        >
          {part}
        </Text>
      ) : (
        <Text key={index}>{part}</Text>
      )
    );
  };
  const cleanHtmlContent = (html) => {
    return html.replace(/<p>(\s|&nbsp;|<br>)*<\/p>/gi, "") // Remove empty p

  };
  
  const processTickContent = (content) => {
    // console.log("text",content);
    if (isHtmlContent(content)) {
      // If it's HTML content, process it accordingly
      return (
        <RenderHtml
          source={{ html: cleanHtmlContent(content) }}
          baseStyle={{
            fontSize: 18,
            fontFamily: GlobalStyles.text.fontFamily,
            color: '#000',
            marginTop: 4,
          }}
          tagsStyles={{
            a: {
              color: 'blue',
              textDecorationLine: 'underline',
            },
            p: {
              marginTop: 10, // Adds space above paragraphs
              marginBottom: 10, // Adds space below paragraphs
              lineHeight: 24, // Improves readability
            },
          }}
          defaultTextProps={{ selectable: true }}
        />
      );
    } else {
      // If it's plain text, process it using processTickText
      return (
        <Text
          fontWeight="400"
          fontSize="18"
          mt={1}
          fontFamily={GlobalStyles.text.fontFamily}
          isSelectable
        >
          {processTickText(content)}
        </Text>
      );
    }
  };
  const stripHtml = (html) => {
    return html?.replace(/<[^>]*>?/gm, "").trim();
  };
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);
  const carouselH        = (screenWidth * 2) / 3;  

    /* ---------- helpers ---------- */
   /* update active dot while swiping */
   const handleScroll = (e) => {
    const x = Platform.OS === "web"
      ? e.target.scrollLeft
      : e.nativeEvent.contentOffset.x;
      const index = Math.floor(x / screenWidth);
      if (index !== activeIndex) {
        setActiveIndex(index);
      }
  };

  /* jump to requested slide (dot click) */
  const jumpTo = (idx) => {
    const offset = idx * screenWidth;
    if (Platform.OS === "web") {
      scrollRef.current?.scrollTo({ left: offset, behavior: "smooth" });
    } else {
      scrollRef.current?.scrollTo({ x: offset, animated: true });
    }
  };

  const imgs = data?.media?.map(doc => doc.url) ?? [];

  function getAvatarChar(fullName) {
    let nameShortCode = "";
    if (fullName && fullName.split(" ").length > 1) {
      nameShortCode =
        fullName.split(" ")[0].charAt(0).toUpperCase() +
        fullName.split(" ")[1].charAt(0).toUpperCase();
    } else {
      nameShortCode = fullName.charAt(0).toUpperCase();
    }
    return nameShortCode;
  }

  const handleChange = useCallback(async (value) => {
    setDetailPopUp(false);
  }, []);

  function getDisplayDate(year, month, day) {
    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    let compDate = new Date(year, month - 1, day); // month - 1 because January == 0
    let diff = today.getTime() - compDate.getTime(); // get the difference between today(at 00:00:00) and the date
    let stringDate = compDate.toDateString().split(" ");
    if (compDate.getTime() > today.getTime()) {
      return stringDate[1] + " " + stringDate[2];
    } else if (compDate.getTime() == today.getTime()) {
      return "Today";
    } else if (diff <= 24 * 60 * 60 * 1000) {
      return "Yesterday";
    } else {
      if (year != today.getFullYear()) {
        return stringDate[1] + " " + stringDate[2] + " " + stringDate[3];
      } else {
        return stringDate[1] + " " + stringDate[2];
      }
    }
  }

  useEffect(async () => {
    console.log(window?.innerWidth || yourDefaultWidth);
  }, []);

  return (
    <>
      <Modal
        size="xl"
        isOpen={modalVisible}
        onClose={closeModal}
        animationType="slide"
        transparent
      >
        <Modal.Content
          backgroundColor={"#43464b"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Modal.CloseButton />
          {imageUrl && (
            <Image
              w={[500, 700, 900]}
              h={[500, 700, 900]}
              source={{ uri: imageUrl }}
              resizeMode="contain"
              // style={{ width: "150%", height: "150%", resizeMode: "contain" }}
            />
          )}
        </Modal.Content>
      </Modal>
      <Center
        m={2}
        _text={{
          color: "warmGray.50",
          fontWeight: "medium",
        }}
      >
        <Box alignItems="center">
          <Box
            rounded="lg"
            borderColor={GlobalStyles.colors.mustard}
            borderWidth="1"
             w={[320, 350, 580]}
          >
            <Stack p="4" w={[320, 350, 580]}>
              <Stack space={2}>
                <Stack alignSelf="flex-end">
                  <Text fontSize="xs">
                    {data?.created_at
                      ? getDisplayDate(
                          data.created_at.split("-")[0],
                          data.created_at.split("-")[1],
                          data.created_at.split("-")[2]
                        )
                      : "few days ago"}
                  </Text>
                </Stack>
                <HStack ml="-2" mt={-5} alignItems="center">
                <HStack alignItems="center" space={2}>
                  <Avatar
                    size="sm"
                    source={{
                      uri: data.user?.logo_url ? data.user?.logo_url : "",
                    }}
                    bg={GlobalStyles.colors.blue}
                  >
                    {
                      data.user?.advertiser_profile?.name
                        ? getAvatarChar(data.user.advertiser_profile.name)
                        : data.user?.business_profile?.name
                        ? getAvatarChar(data.user.business_profile.name)
                        : getAvatarChar("")
                    }
                  </Avatar>

                  <Heading
                    mt={2}
                    size="sm"
                    fontFamily={GlobalStyles.text.fontFamily}
                  >
                    <Text fontSize={18}>
                      {
                        data?.user?.advertiser_profile?.name
                          ? data.user.advertiser_profile.name
                          : data?.user?.business_profile?.name
                          ? data.user.business_profile.name
                          : ""
                      }
                    </Text>
                  </Heading>
                </HStack>

                {/* Spacer pushes the next item to the right end */}
                <Spacer />

                
                <Stack mt={3}>
                  <Text
                    bg={GlobalStyles.colors.mustard}
                    _dark={{ bg: "violet.400" }}
                    p={2}
                    _text={{
                      color: "warmGray.50",
                      fontWeight: "700",
                      fontSize: "sm",
                    }}
                  >
                    {data?.productTags?.length > 0
                        ? data.productTags[0]?.tag?.title
                        : ""}
                  </Text>
                </Stack>
              </HStack>
              </Stack>
              <Text
                fontWeight="400"
                mt={3}
                fontSize={18}
                fontFamily={GlobalStyles.text.fontFamily}
                noOfLines={3}
              >
                {processTickContent(data.title || "")}
                {/* Bengaluru (also called Bangalore) is the center of India's
                high-tech industry. The city is also known for its parks and
                nightlife. */}
              </Text>
            </Stack>
            <Box>
            {/* ---------- SLIDE STRIP ---------- */}
            {Platform.OS === "web" ? (
              <div
                ref={scrollRef}
                onScroll={handleScroll}
                style={{
                  display: "flex",
                  overflowX: "auto",
                  width:  screenWidth,
                  // height: carouselH,
                  scrollSnapType: "x mandatory",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {imgs.map((url, idx) => (
                  <div
                    key={idx}
                    style={{
                      width: screenWidth,
                      height: carouselH,
                      scrollSnapAlign: "center",
                      flexShrink: 0,
                    }}
                    onClick={() => openModal?.(idx)}
                  >
                    <img
                      src={url}
                      alt={`img-${idx}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: 8,
                        display: "block",
                      }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <ScrollView
                ref={scrollRef}
                horizontal
                pagingEnabled
                onScroll={handleScroll}
                scrollEventThrottle={16}
                showsHorizontalScrollIndicator={false}
                style={{ width: screenWidth, height: carouselH }}
              >
                {imgs.map((url, idx) => (
                  <Pressable key={idx} onPress={() => openModal?.(idx)}>
                    <Box width={screenWidth} height={carouselH}>
                      <img
                        src={url}
                        alt={`img-${idx}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 8,
                          display: "block",
                        }}
                      />
                    </Box>
                  </Pressable>
                ))}
              </ScrollView>
            )}

            {/* ---------- DOTS ---------- */}
            {imgs.length > 1 && (
              <View style={{ flexDirection: "row", justifyContent: "center", marginTop: 8 }}>
                {imgs.map((_, idx) => (
                  <Pressable key={idx} onPress={() => jumpTo(idx)}>
                  <Box
                    width={2}
                    height={2}
                    borderRadius="50%"
                    mx={1}
                    bg={idx === activeIndex ? "#002061" : "#E5E4E2"}
                  />
                </Pressable>

                ))}
              </View>
            )}
          </Box>
            {user.user_category == GlobalConstants.userCategories.citizen.id ? (
              <HStack p="1" w={[250, 250, 600]} justifyContent="space-between">
                <Stack w={[window?.innerWidth > 600 && 200]}>
                  <Button
                    leftIcon={
                      <Image
                        source={require("../../assets/save.png")}
                        alt="Save"
                        size="7"
                      />
                      // <MaterialIcons name="save" size={24} color="black" />
                    }
                    isDisabled={data.savedAllowed ? false : true}
                    size="sm"
                    variant="unstyled"
                    onPress={() => {
                      data.isSave =
                        data?.user_saved_ads?.length > 0 ? false : true;
                      if (data.isSave) {
                        data.user_saved_ads = [{}];
                        setSaveButtonText("UnSave");
                      } else {
                        data.user_saved_ads = [];
                        setSaveButtonText("Save");
                      }
                      setSelectedPost(data);
                    }}
                  >
                    {saveButtonText}
                  </Button>
                </Stack>
                <Stack w={[window?.innerWidth > 600 && 200]}>
                  <Button
                    isDisabled={!data.text}
                    leftIcon={
                      <Image
                        source={require("../../assets/detail.png")}
                        alt="Save"
                        size="7"
                      />
                      // <MaterialIcons name="list-alt" size={24} color="black" />
                    }
                    size="sm"
                    variant="unstyled"
                    onPress={() => {
                      setDetailPopUp(true);
                    }}
                  >
                    Detail
                  </Button>
                </Stack>
                <Stack w={[window?.innerWidth > 600 && 200]}>
                  <Button
                    leftIcon={
                      <Image
                        source={require("../../assets/share.png")}
                        alt="Save"
                        size="7"
                      />
                    }
                    size="sm"
                    variant="unstyled"
                    onPress={openClipboardPopup}
                  >
                    Share
                  </Button>
                </Stack>
              </HStack>
            ) : (
              <HStack p="1" w={[250, 250, 600]} justifyContent="space-between">
                <Stack w={[window?.innerWidth > 600 ? 100 : 70]}>
                  <Button
                    isDisabled={!data.details}
                    leftIcon={
                      <Image
                        source={require("../../assets/detail.png")}
                        alt="Save"
                        size="7"
                      />
                      // <MaterialIcons name="list-alt" size={24} color="black" />
                    }
                    size="sm"
                    variant="unstyled"
                    onPress={() => {
                      setDetailPopUp(true);
                    }}
                  >
                    Detail
                  </Button>
                </Stack>
                <Stack w={[window?.innerWidth > 600 ? 100 : 70]}>
                  <Button
                    leftIcon={
                      <Image
                        source={require("../../assets/share.png")}
                        alt="Save"
                        size="7"
                      />
                    }
                    size="sm"
                    variant="unstyled"
                    onPress={openClipboardPopup}
                  >
                    Share
                  </Button>
                </Stack>
                <Stack w={[window?.innerWidth > 600 ? 100:70]}>
                <Button
                  leftIcon={
                    <MaterialIcons
                      name="delete-outline"
                      size={24}
                      color="black"
                    />
                  }
                  size="sm"
                  variant="unstyled"
                  onPress={() => {
                    setSelectedPost(data.id);
                  }}
                >
                  {"Delete"}
                </Button>
              </Stack>
              </HStack>
            )}
          </Box>
        </Box>
      </Center>

      <ClipboardPopup
        isOpen={isClipboardPopupOpen}
        onClose={closeClipboardPopup}
        onShare={shareClipboardPopup}
        url={window.location.host + "/invite/ad/" + data.id}
        friends={[]}
      />

      {detailPopUp ? (
        <CustomPopup
          heading="Detail"
          body={processTickContent(data.details || "No details available")}
          data={detailPopUp}
          onChange={handleChange}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default AdCardForCitizen;
